import React from "react";
import './Loading.css'
import {useLoadingState} from "../../context/LoadingContext";
import loadingAnim from '../../assets/lottie/loading.json';
import {Player} from "@lottiefiles/react-lottie-player";

export default function Loading() {

    const loadingState = useLoadingState()

    return (
        <div className={` ${loadingState.loading ? 'd-block' : 'd-none'}`}>
            <div
                className={` ${loadingState.showBackground ? 'loading loadingBackgroundWhite' : 'loading loadingBackgroundBlur'}`}>
                <div>
                    <Player
                        src={loadingAnim}
                        loop
                        autoplay
                        style={{ height: '100px', width: '100px' }}
                    />
                </div>
            </div>

        </div>
    )
}
